import type { SurfaceId } from "../types";

const SURFACES: { id: SurfaceId; label: string; group?: "v1" | "v2" }[] = [
  { id: "deck", label: "Command Deck", group: "v2" },
  { id: "pipeline", label: "Pipeline", group: "v2" },
  { id: "agents", label: "Agents", group: "v2" },
  { id: "recovery", label: "Recovery", group: "v2" },
  { id: "portfolio", label: "Portfolio", group: "v2" },
  { id: "intake", label: "Build Intake", group: "v1" },
  { id: "grader", label: "Repo Grader", group: "v1" },
  { id: "forge", label: "Prompt Forge", group: "v1" },
  { id: "planner", label: "Artifact Planner", group: "v1" },
  { id: "merge", label: "Merge Planner", group: "v1" },
  { id: "runtime", label: "Sovereign Runtime", group: "v1" },
  { id: "export", label: "Export Center", group: "v1" },
];

interface Props {
  active: SurfaceId;
  onSelect: (id: SurfaceId) => void;
}

export function NavTabs({ active, onSelect }: Props) {
  return (
    <nav className="nav-tabs" aria-label="BOB surfaces">
      {SURFACES.map((s) => (
        <button
          key={s.id}
          type="button"
          className={`nav-tab ${active === s.id ? "active" : ""} ${s.group === "v2" ? "nav-tab-v2" : ""}`}
          onClick={() => onSelect(s.id)}
        >
          {s.label}
        </button>
      ))}
    </nav>
  );
}
